import { isBrowser, getPreviousUrl } from "@helpers/browser";

export function expSendAddToCartFromVto(products) {
  if (isBrowser && window.exponea) {
    const data = products.reduce(
      (acc, p) => {
        acc.quantity += p.quantity;
        acc.totalValue += p.variant.price;
        acc.products.push({
          variantId: p.variant.id.replace("gid://shopify/ProductVariant/", ""),
          sku: p.variant.sku,
          title: p.variant.product.title,
          price: p.variant.price * p.quantity,
        });
        return acc;
      },
      {
        quantity: 0,
        totalValue: 0,
        products: [],
      }
    );
    if (data && data.quantity > 0) {
      window.exponea.track("add_to_cart_vto", {
        ...data,
      });
    }
  }
}

export function expSendViewProductPage({ price, title, productType, productId }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("view_item", {
      product_id: productId,
      price: parseFloat(price), // FLOAT
      title,
      brand: "Ana Luisa",
      category_1: productType,
      previous_url: getPreviousUrl(),
    });
  }
}

export function expSendAddToWishlist({ productHandle, price, productId, email }) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("add_item_wishlist", {
        product_id: productId,
        title: productHandle,
        price,
        email,
      });
    }
  }
}

export function expSendRemoveFromWishlist({ productHandle, price, productId, email }) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("remove_item_wishlist", {
        product_id: productId,
        title: productHandle,
        price,
        email,
      });
    }
  }
}

export function expTrackRecommendedProduct(action, data) {
  if (isBrowser && window.exponea) {
    window.exponea.track("recommended_product", { action, ...data });
  }
}

export function expSendUserSignup({ email, httpStatus, data }) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("user_signup", { email, httpStatus, data });
    }
  }
}

export function expTrackClickAlternative({
  page,
  activeProductHandle,
  activeProductColor,
  alternativeHandle,
  alternativeColor,
}) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("click_alternative", {
        page,
        activeProductHandle,
        activeProductColor,
        alternativeHandle,
        alternativeColor,
      });
    }
  }
}

export function expTrackMtoShuffle({ stones }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("mto_shuffle", { stones });
  }
}

export function expSendUserLogin({ email }) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("user_login", { email });
    }
  }
}

/**
 * action: SIGNUP, LOGIN, FORGOT_PASSWORD, LOGOUT, ACTIVATE_ACCOUNT
 */
export function expSendAccountError({ action, errorMessage, email }) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("account_error", { action, errorMessage, email });
    }
  }
}

export function expSendSideCartOpen({ cart, currency }) {
  if (isBrowser) {
    if (window.exponea) {
      const linesStr = cart?.lines
        ?.filter((line) => line.variant.sku !== "L-0001") // exclude Luxe
        ?.map((line) => {
          const id = line?.variant?.id.replace("gid://shopify/ProductVariant/", "");
          return `${id};${line?.quantity}`;
        })
        .join(",");

      const data = {
        ...cart,
        currency,
        linesStr,
      };
      window.exponea.track("view_sidecart", data);
    }
  }
}

export function expSendMenuClick({
  destinationUrl,
  menuTitle,
  categoryTitle,
  subCategoryTitle,
  sourceType,
}) {
  if (isBrowser && window.exponea) {
    window.exponea.track("main_menu_click", {
      sourceType,
      destinationUrl,
      menuTitle,
      categoryTitle,
      subCategoryTitle,
    });
  }
}

export function expSendCollectionFilterClick({ category, title, turningOn }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("collection_filter_click", {
      category,
      title,
      action: turningOn ? "turn_on" : "turn_off",
    });
  }
}

export function expSendCollectionSortClick({ value }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("collection_sort_click", {
      sort_value: value,
    });
  }
}

export function expSendFloatingAddToCart({
  price,
  title,
  variantId,
  productId,
  sku,
  category,
  currency,
}) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("floating_add_to_cart", {
        price,
        title,
        variantId,
        productId,
        sku,
        category,
        currency,
        previous_url: getPreviousUrl(),
      });
    }
  }
}

export function expTrackCollectionCards({ collectionHandle, link, title }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("plp_cards", {
      collectionHandle,
      link,
      title,
      action: "click",
    });
  }
}

export function expTrackSubscriptionCancel(reason) {
  if (isBrowser && window.exponea) {
    window.exponea.track("subscription_change", {
      type: "CANCEL",
      time: 0,
      reason,
    });
  }
}

export function expTrackSubscriptionSkip() {
  if (isBrowser && window.exponea) {
    window.exponea.track("subscription_change", {
      type: "PAUSE",
      time: 1,
    });
  }
}

export function expTrackSubscriptionPause(interval) {
  if (isBrowser && window.exponea) {
    window.exponea.track("subscription_change", {
      type: "PAUSE",
      time: interval,
    });
  }
}

export function expTrackSubscriptionReactivate() {
  if (isBrowser && window.exponea) {
    window.exponea.track("subscription_change", {
      type: "REACTIVATE",
      time: 0,
    });
  }
}

export function expTrackSubscriptionRefund({ orderId, amount }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("subscription_change", {
      type: "REFUND",
      orderId,
      amount,
    });
  }
}

export function expTrackAddToCart({
  product_ids,
  product_id,
  product_list,
  sku_ids,
  sku_list,
  variant_ids,
  variant_list,
  total_price,
  total_price_local_currency,
  total_quantity,
  image_list,
  linesStr,
  component_name = "",
  category = "",
  bundle,
}) {
  if (isBrowser && window.exponea) {
    const d = {
      action: "add",
      product_ids,
      product_id,
      product_list,
      sku_ids,
      sku_list,
      variant_ids,
      variant_list,
      total_price,
      total_price_local_currency,
      total_quantity,
      image_list,
      linesStr,
      component_name,
      category,
      bundle,
      previous_url: getPreviousUrl(),
    };
    window.exponea.track("cart_update", d);
  }
}

export function expOptionalProductsDrawerOpen({ originProductTitle }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("optional_products_drawer_open", {
      from: originProductTitle,
    });
  }
}

export function expOptionalProductsDrawerAdd({ originProductTitle, handle, price, currency }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("optional_products_drawer_add", {
      from: originProductTitle,
      handle,
      price,
      currency,
    });
  }
}

export function expOptionalProductsDrawerRemove({ originProductTitle, handle, price, currency }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("optional_products_drawer_remove", {
      from: originProductTitle,
      handle,
      price,
      currency,
    });
  }
}

export function expOptionalProductsDrawerEdit({
  originProductTitle,
  addedHandles,
  price,
  currency,
}) {
  if (isBrowser && window.exponea) {
    window.exponea.track("optional_products_drawer_edit", {
      from: originProductTitle,
      handles: addedHandles,
      price,
      currency,
      quantity: addedHandles.length,
    });
  }
}

export function expOptionalProductsDrawerConfirmation({
  originProductTitle,
  handles,
  price,
  currency,
}) {
  if (isBrowser && window.exponea) {
    window.exponea.track("optional_products_drawer_confirm", {
      from: originProductTitle,
      handles,
      price,
      currency,
      quantity: handles.length,
    });
  }
}

export function expTrackRemoveFromCart({
  productId,
  product_ids,
  title,
  price,
  currency,
  category,
  quantity,
}) {
  if (isBrowser && window.exponea) {
    window.exponea.track("cart_update", {
      action: "remove",
      productId,
      product_ids,
      title,
      price,
      currency,
      category,
      quantity,
    });
  }
}

export function expTrackCountryUpdate({ country }) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("country_update", country);
    }
  }
}

export function expTrackCartRecovery({
  isSuccess,
  cartId,
  numberLines,
  countryCode,
  totalValue,
  numberItems,
}) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("cart_recovery", {
        isSuccess,
        cartId,
        numberLines,
        countryCode,
        totalValue,
        numberItems,
      });
    }
  }
}

export function expTrackAddFreeGift({ productId, productTitle, productHandle, type }) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("add_free_gift", {
        product_id: productId,
        product_title: productTitle,
        product_handle: productHandle,
        type,
      });
    }
  }
}

export function expTrackSwapFreeGift() {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("swap_free_gift");
    }
  }
}

export function expCancelOrder({ orderId, reason, status }) {
  if (isBrowser) {
    if (window.exponea) {
      window.exponea.track("cancel_order", {
        orderId,
        reason,
        status,
      });
    }
  }
}
export function expRecommendedProductsPopupAction({ type }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("recommended_products_popup_action", {
      type,
    });
  }
}

export function expRecommendedProductsATC({ type, handles }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("recommended_products_add_to_cart", {
      type,
      handles,
    });
  }
}

export function expTrackBYOBCartActions({
  action,
  productHandle,
  collectionHandle,
  noOfProducts,
  allSavings,
}) {
  if (isBrowser && window.exponea) {
    window.exponea.track("byob_cart_action", {
      action,
      productHandle,
      collectionHandle,
      noOfProducts,
      allSavings,
    });
  }
}

export function expTrackBYOBAddToCart({
  productsHandles,
  collectionHandle,
  productsVariantsIds,
  savings,
  subtotal,
  total,
}) {
  if (isBrowser && window.exponea) {
    window.exponea.track("byob_add_to_cart", {
      productsHandles,
      collectionHandle,
      productsVariantsIds,
      savings,
      subtotal,
      total,
    });
  }
}

export function expTrackBYOBFiltersActions({ action, filters, changedFilter }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("byob_filters_actions", {
      action,
      filters,
      changedFilter,
    });
  }
}

export function expTrackDowngradeSubscriptionPopup({ action, subscriptionPrice }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("downgrade_subscription_popup", {
      action,
      subscriptionPrice,
    });
  }
}

export function extTrackDowngradeSubscriptionConfirmation({ subscriptionPrice }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("downgrade_subscription_confirmation", {
      subscriptionPrice,
    });
  }
}

export function extTrackDowngradeSubscriptionCancel() {
  if (isBrowser && window.exponea) {
    window.exponea.track("downgrade_subscription_cancel");
  }
}
export function expTrackBYOBPopupActions({ action, productHandle, collectionHandle }) {
  if (isBrowser && window.exponea) {
    window.exponea.track("byob_product_popup", {
      action,
      productHandle,
      collectionHandle,
    });
  }
}

const GIFT_PACKAGING_ACTIONS = [
  "add_packaging_click",
  "edit_packaging_click",
  "remove_packaging_click",
  "close",
  "continue_button_click",
  "review_button_click",
  "checkout_button_click",
];

export function expTrackGiftPackagingActions({ action, productId }) {
  if (!isBrowser || !window.exponea) {
    return;
  }
  if (!GIFT_PACKAGING_ACTIONS.includes(action)) {
    return;
  }
  const includesProductId = action !== "add_packaging_click" && action !== "close";

  window.exponea.track(`gift_packaging_${action}`, {
    action,
    ...(includesProductId ? { productId } : {}),
  });
}
